import {
    FETCH_MACHINES_SUCCESS,
    FETCH_MACHINES_FAILURE,
    FETCH_EXCHANGERATES_SUCCESS,
    FETCH_EXCHANGERATES_FAILURE,
    FETCH_MACHINES_UPDATED_SUCCESS,
    FETCH_MACHINES_UPDATED_FAILURE,
    SET_CENTER,
    SET_CENTER_TO_CURRENT_COORDINATES,
    SET_ZOOM,
    SET_MARKER,
    SET_LIST_MARKERS,
    SET_LIST_ACTIVE,
    SET_FILTER,
    SET_FILTERED_ITEMS,
    SET_CLOSEST_FILTERED_MARKER,
    SET_USER_POS,
    SET_USER_POS_ERROR,
    SET_MAP,
    SET_INFOWINDOW,
    SET_EXTERNAL_GEOLOCATION,
    SET_SEARCH_VALUE,
    USER_POSITION_FETCHED,
    QUERY_MARKER_OPENED,
    SET_MAP_CONTAINER_DIMENSIONS
} from '../constants/actionTypes';

export function fetchMachinesSuccess(data, timestamp) {
    return {
        type: FETCH_MACHINES_SUCCESS,
        data: data,
        timestamp: timestamp
    };
}

export function fetchMachinesFailure(message) {
    return {
        type: FETCH_MACHINES_FAILURE,
        message: message
    };
}

export function fetchMachinesUpdatedSuccess(data, timestamp) {
    return {
        type: FETCH_MACHINES_UPDATED_SUCCESS,
        data: data,
        timestamp: timestamp
    };
}

export function fetchMachinesUpdatedFailure(message) {
    return {
        type: FETCH_MACHINES_UPDATED_FAILURE,
        message: message
    };
}

export function fetchExchangeRatesSuccess(data) {
    return {
        type: FETCH_EXCHANGERATES_SUCCESS,
        data: data
    };
}

export function fetchExchangeRatesFailure(message) {
    return {
        type: FETCH_EXCHANGERATES_FAILURE,
        message: message
    };
}

export function setCenter(center) {
    return {
        type: SET_CENTER,
        center: center,
    };
}

export function setCenterToCurrentCoordinates() {
    return {
        type: SET_CENTER_TO_CURRENT_COORDINATES
    };
}

export function setZoom(zoom) {
    return {
        type: SET_ZOOM,
        zoom: zoom,
    };
}

export function setMarker(activeMarker) {
    return {
        type: SET_MARKER,
        activeMarker: activeMarker,
    };
}

export function setListMarkers(listMarkers) {
    return {
        type: SET_LIST_MARKERS,
        listMarkers: listMarkers
    };
}

export function setListActive(listActive) {
    return {
        type: SET_LIST_ACTIVE,
        listActive: listActive
    };
}

export function setFilter(filter) {
    return {
        type: SET_FILTER,
        filter: filter,
    };
}

export function setFilteredItems(items) {
    return {
        type: SET_FILTERED_ITEMS,
        filteredItems: items
    }
}

export function setClosestFilteredMarker() {
    return {
        type: SET_CLOSEST_FILTERED_MARKER
    };
}

export function setUserPos(userPos) {
    return {
        type: SET_USER_POS,
        userPos: userPos
    };
}

export function setUserPosError(error) {
    return {
        type: SET_USER_POS_ERROR,
        error: error,
    };
}

export function setMap(map) {
    return {
        type: SET_MAP,
        map: map
    };
}

export function setInfoWindow(infowindow) {
    return {
        type: SET_INFOWINDOW,
        infowindow: infowindow
    };
}

export function setExternalGeolocation(externalGeolocation) {
    return {
        type: SET_EXTERNAL_GEOLOCATION,
        externalGeolocation: externalGeolocation
    };
}

export function userPositionFetched() {
    return {
        type: USER_POSITION_FETCHED
    };
}

export function setQueryMarkerOpened() {
    return {
        type: QUERY_MARKER_OPENED
    };
}

export function setSearchvalue(searchValue) {
    return {
        type: SET_SEARCH_VALUE,
        searchValue: searchValue
    };
}

export function setMapContainerDimensions(dims) {
    return {
        type: SET_MAP_CONTAINER_DIMENSIONS,
        dimensions: dims
    };
}
